import React, { FC, useState, useRef } from 'react'
import { Trans, t } from '@lingui/macro'
import {
  ButtonClean,
  ButtonDanger,
  ButtonPrimary,
  Flex
} from 'front-end/src/components'
import { Modal } from '../../../components/common/modal/Modal'
import Spinner from '../../../components/common/spinner/Spinner'
import './MembersList.less'

import { AccessBanner } from '../../../components/common/access-banner/AccessBanner'
import { AddMembersModal } from '../add-members-modal/AddMembersModal'
import IconLock from '../../../components/common/icon/IconLock'

import { useSetWorkspaceOpenessMutation } from './WorkspaceMembersTab.codegen'
import { WorkspaceGroups } from './WorkspaceGroups'
import { WorkspaceUsers } from './WorkspaceUsers'
import { useWorkspaceBasicInfoQuery } from '../ManageWorkspacePage.codegen'

export const mapRolesToSelectOptions = (): Array<{
  value: string
  label: string
}> => {
  const workspaceUserRoles = {
    COORDINATOR: { label: t`Can edit resources, members and reports` },
    COLLABORATOR: { label: t`Can edit resources` },
    MEMBER: { label: t`Can view resources` }
  }

  return Object.entries(workspaceUserRoles).map((entry) => {
    const [key, values] = entry
    return {
      value: key,
      label: values.label
    }
  })
}

export const WorkspaceMembersTab: FC<{
  workspaceId: number
}> = (props) => {
  const [showAddMembersModal, setShowAddMembersModal] = useState(false)
  const [showConfirmPrivateModal, setShowConfirmPrivateModal] = useState(false)
  const groupsRef = useRef()
  const usersRef = useRef()

  const { data, loading, refetch } = useWorkspaceBasicInfoQuery({
    variables: {
      workspaceId: props.workspaceId
    }
  })

  const [setIsOpen] = useSetWorkspaceOpenessMutation()

  if (
    (!data && loading) ||
    data?.workspace?.__typename !== 'WorkspaceModelAsCoordinator'
  ) {
    return null
  }

  const { workspaceId } = props
  const { is_open } = data.workspace
  return (
    <>
      <AccessBanner
        subject={t`Workspace`}
        isPublic={is_open}
        onToggle={async () => {
          if (is_open) {
            setShowConfirmPrivateModal(true)
          } else {
            await setIsOpen({
              variables: {
                workspaceId: workspaceId,
                is_open: true
              }
            })
            refetch()
          }
        }}
      />
      <Modal
        show={showConfirmPrivateModal}
        header={t`Changing workspace access from OPEN to PRIVATE`}
        subHeader={t`This will archive all stored Analytics data of this Workspace except data about People and Groups already have access.`}
        controls={[
          <ButtonClean
            key={1}
            onClick={() => setShowConfirmPrivateModal(false)}
          >
            <Trans>Cancel</Trans>
          </ButtonClean>,
          <ButtonDanger
            key={2}
            onClick={async () => {
              await setIsOpen({
                variables: {
                  workspaceId: workspaceId,
                  is_open: false
                }
              })
              refetch()
              setShowConfirmPrivateModal(false)
            }}
            leftIcon={<IconLock />}
          >
            <Trans>Change to PRIVATE</Trans>
          </ButtonDanger>
        ]}
      />

      <div className="MembersList">
        {loading && (
          <div className="MembersList__overlay-spinner">
            <Spinner />
          </div>
        )}
        <Flex justifyContent="flex-end">
          <ButtonPrimary
            onClick={() => {
              setShowAddMembersModal(true)
            }}
          >
            <Trans>Add groups or users</Trans>
          </ButtonPrimary>
        </Flex>
        {/* @ts-expect-error  9/11/2020*/}
        <WorkspaceGroups workspaceId={workspaceId} ref={groupsRef} />
        {/* @ts-expect-error  9/11/2020*/}
        <WorkspaceUsers workspaceId={workspaceId} ref={usersRef} />
      </div>
      <AddMembersModal
        show={showAddMembersModal}
        workspaceId={workspaceId}
        onSubmitted={() => {
          setShowAddMembersModal(false)
          // @ts-expect-error 9/11/2020
          groupsRef.current?.onGroupsChange()
          // @ts-expect-error 9/11/2020
          usersRef.current?.onUsersChange()
        }}
        onCancel={() => {
          setShowAddMembersModal(false)
        }}
      />
    </>
  )
}
